import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Button from '../ui/Button';
import site from '../../data/site.json';
import stats from '../../data/stats.json';
import './Hero.css';

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};
const item = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

const Hero = () => {
  const { hero } = site;
  const ref = useRef(null);

  // Scroll-linked parallax: background slow-zooms, content drifts + fades out.
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start start', 'end start'],
  });
  const bgScale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);
  const contentY = useTransform(scrollYProgress, [0, 1], ['0%', '22%']);
  const contentOpacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="hero" id="top" ref={ref}>
      <motion.div className="hero__bg" style={{ scale: bgScale }}>
        <video
          className="hero__video"
          autoPlay
          loop
          muted
          playsInline
          src={process.env.PUBLIC_URL + hero.videoSrc}
        />
        <div className="hero__scrim" />
        <div className="hero__glow" />
      </motion.div>

      <motion.div
        className="hero__content tra-container"
        variants={container}
        initial="hidden"
        animate="show"
        style={{ y: contentY, opacity: contentOpacity }}
      >
        <motion.span className="hero__eyebrow tra-eyebrow" variants={item}>
          {hero.eyebrow}
        </motion.span>

        <motion.h1 className="hero__headline" variants={item}>
          We turn gaming audiences into{' '}
          <span className="tra-gradient-text">loyal customers</span>
        </motion.h1>

        <motion.p className="hero__sub" variants={item}>
          {hero.subheadline}
        </motion.p>

        <motion.div className="hero__ctas" variants={item}>
          <Button onClick={() => scrollTo('contact')} variant="primary" size="lg" arrow>
            {hero.ctaPrimary.text}
          </Button>
          <Button onClick={() => scrollTo('creators')} variant="secondary" size="lg">
            {hero.ctaSecondary.text}
          </Button>
        </motion.div>

        <motion.div className="hero__stats" variants={item}>
          {stats.map((s) => (
            <div key={s.label} className="hero__stat">
              <span className="hero__stat-value">{s.value}</span>
              <span className="hero__stat-label">{s.label}</span>
            </div>
          ))}
        </motion.div>
      </motion.div>

      <button className="hero__scroll" onClick={() => scrollTo('work')} aria-label="Scroll down">
        <span>Scroll</span>
        <div className="hero__scroll-line" />
      </button>
    </section>
  );
};

export default Hero;
